import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';

export default class MenuItemViewModel extends ControlViewModel {

    /**
     * Gibt an, ob das Item geöffnet ist
     */
    public isOpen: KnockoutObservable<boolean>;

    /**
     * Enthält den Link
     */
    public link: LinkViewModel;

    /**
    * Das ViewModel für das zusätzliche Icon, das standartmäßig rechts dargestellt wird
    */
    public image: ImageViewModel;

    /**
     * Die Items des Menu
     */
    public items: KnockoutObservable<MenuItemViewModel[]>;

    /**
     * Das ViewModel für ein MenuItem
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.isOpen = this.observableOrDefault(params.isOpen, false);
        this.defineSubscription(this.isOpen, (val) => {
            for (let i = 0; i < this.items().length; i++) {
                this.items()[i].isOpen.valueWillMutate();
                this.items()[i].isOpen(false);
                this.items()[i].isOpen.valueHasMutated();
            }
        });
        this.link = this.paramOrDefault(params.link, null);
        this.image = this.paramOrDefault(params.image, null);
        this.items = this.observableOrDefault(params.items, []);
    }
}

ComponentManager.setViewModel('MenuItemViewModel', MenuItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');